import {
  Box,
  Button,
  Divider,
  Grid,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import FormDialog from "common/Modal/Modal";
import AddIcon from "@mui/icons-material/Add";
import { InventoryItemsTable } from "components/Inventory/InventoryItemsTable";
import { useSnackbar } from "notistack";
import { useGetItemsDropdownService } from "subModule/src/services/items/useItems";
import { selectUserInfo } from "features/user/userSlice";
import { useSelector } from "react-redux";
import AlertMessages from "common/Alert/AlertMessages";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  InventoryProfileService,
  TaxProcedureProfileService,
} from "subModule/src/core/services";
import {
  GetStockReceiptResponse,
  NewPurchaseOrderResponse,
  PurchaseOrderResponse,
  PurchaseOrderStatuses,
  SaveInvoiceResponse,
} from "subModule/src/services/inventory/interface";
import Loader from "layout/Loader";
import { useTranslation } from "react-i18next";
import { DeleteData } from "subModule/src/type";
import { useGetServicesDropdownService } from "subModule/src/services/service/useService";
import { InventoryServicesTable } from "components/Inventory/InventoryServicesTable";
import BasicDatePicker from "common/Pickers/Pickers";
import dayjs from "dayjs";
import { GetDefaultTaxProcedureResponse } from "@subModule/src/services/taxProcedure/interface";
import { themes } from "theme/themes";
import { brandingInfo } from "features/server/brandingSlice";
// import { ReactComponent as Completed } from "assets/completed.svg";
import {
  useGetPurchaseOrderByIdService,
  useGetPurchaseOrderStatusesService,
} from "subModule/src/services/inventory/useInventory";
import { GetItemsDropdownResponse } from "subModule/src/services/items/interface";
import CommonCheckbox from "common/CheckBox/Checkbox";
import DynamicSelect from "common/Select/Select";
import { useGetTaxProcedureDropdownService } from "subModule/src/services/taxProcedure/useTaxProcedure";
interface FormData {
  [key: string]: any;
}
interface PurchaseInvoiceProps {
  steps: string[];
  setCurrentSteps?: any;
}

const PurchaseInvoice: React.FC<PurchaseInvoiceProps> = ({
  steps,
  setCurrentSteps,
}) => {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const supplierId = (location.state as { supplier?: number | null })?.supplier;
  const handleBack = () =>
    supplierId ? navigate(-1) : navigate("/inventory/purchase-orders");
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);
  const loggedInUserCurrency = useSelector(selectUserInfo)?.business?.currency;
  const { enqueueSnackbar } = useSnackbar();
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
    resetField,
  } = useForm<FormData>({
    defaultValues: {
      purchaseInvoiceItem: [],
      purchaseInvoiceService: [],
      taxable: false,
      taxProcedureId: null,
    },
  });
  const [dropdownSearchTerm, setDropdownSearchTerm] = useState<any>("");
  const [dropdownPage, setDropdownPage] = useState<number>(1);
  const [searchLoading, setSearchLoading] = useState<string | null>(null);
  const [po, setInvoice] = useState<PurchaseOrderResponse>();
  const { data: itemsData, refetch: itemsRefetch } = useGetItemsDropdownService(
    {
      pageNumber: dropdownPage,
      size: 20,
      storeId: po?.storeId || 0,
      search: dropdownSearchTerm,
    },
  );
  const { data: servicesData, refetch: servicesRefetch } =
    useGetServicesDropdownService({
      pageNumber: dropdownPage,
      size: 20,
      search: dropdownSearchTerm,
    });
  const { data: taxProceduresData, refetch: taxProceduresRefetch } =
    useGetTaxProcedureDropdownService({
      pageNumber: dropdownPage,
      size: 50,
      title: dropdownSearchTerm,
    });
  const { data: poStatusesData, refetch: poStatusesRefetch } =
    useGetPurchaseOrderStatusesService(+(params as any)?.id);
  const { refetch: poByIdFetch } = useGetPurchaseOrderByIdService(params?.id);
  const [currentStep, setCurrentStep] = useState<number>(
    steps.indexOf("supplierBill"),
  );
  const [confirm, setConfirm] = useState<boolean>(false);
  const [purchaseInvoiceItem, setPurchaseInvoiceItem] = useState<any[]>([]);
  const [purchaseInvoiceService, setPurchaseInvoiceService] = useState<any[]>(
    [],
  );
  const [entity, setEntity] = useState<FormData>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [IsDataAvailable, setIsDataAvailable] = useState<boolean>(false);
  const [checkStatus, setCheckStatus] = useState<number | null>(1);
  const [taxPercentage, setTaxPercentage] = useState<number>(0);
  const [allStatuses, setAllStatuses] = useState<PurchaseOrderStatuses>({});
  const [partsLoader, setPartsLoader] = useState<boolean>(true);
  useEffect(() => {
    setTimeout(() => setLoading(true), 10);
    poStatusesRefetch();
    servicesRefetch();
    taxProceduresRefetch();
    if (params?.id) {
      getStockReceiptByPOId();
    }
  }, [currentStep]);
  useEffect(() => {
    setAllStatuses(poStatusesData?.data || {});
  }, [poStatusesData]);
  useEffect(() => {
    if (po?.storeId) getParts();
  }, [po?.storeId && currentStep]);
  const getParts = async () => {
    await itemsRefetch()
      .then((res: GetItemsDropdownResponse | unknown | any) => {
        if (res?.data?.pages[0]?.success) {
          ///
        } else {
          enqueueSnackbar(
            <AlertMessages
              text={res?.data?.message || "Something went wrong"}
            />,
            { variant: "error" },
          );
        }
      })
      .catch((err) => {
        console.error("===", err);
      })
      .finally(() => setPartsLoader(false));
  };
  const getStockReceiptByPOId = () => {
    InventoryProfileService.getStockReceiptByPOID(params?.id)
      .then((res: GetStockReceiptResponse) => {
        if (!res.data) {
          setIsDataAvailable(false);
          getInvoiceById();
        } else {
          setIsDataAvailable(true);
          setLoading(false);
          getInvoiceById();
        }
      })
      .catch((err: any) => {
        console.error("===", err);
        setLoading(false);
      });
  };
  const getInvoiceById = () => {
    InventoryProfileService.getInvoiceByPOID(params?.id)
      .then((res: SaveInvoiceResponse) => {
        if (res.data) {
          setIsDataAvailable(true);
          setCheckStatus((res.data as any)?.status);
          setInvoice(res.data as any);
          if (res.data?.status === 2) setPartsLoader(false);
          setPurchaseInvoiceItem((res.data as any)?.purchaseInvoiceItem || []);
          setValue("purchaseInvoiceItem", res.data.purchaseInvoiceItem || []);
          setPurchaseInvoiceService(
            (res.data as any)?.purchaseInvoiceService || [],
          );
          setValue(
            "purchaseInvoiceService",
            res.data?.purchaseInvoiceService || [],
          );
          setValue("storeId", res.data?.storeId);
          setValue("poId", params?.id);
          setValue("invoiceIndex", res.data?.invoiceIndex);
          setValue("invoiceNumber", res.data?.invoiceNumber);
          setValue("invoiceDate", res.data?.invoiceDate?.split(" ")[0]);
          setValue("dueDate", res.data?.dueDate?.split(" ")[0] || null);
          setValue("comments", res.data?.poMemo);
          setValue("supplierId", res.data?.supplierId);
          setValue("referenceNumber", res.data?.referenceNumber);
          setValue(
            "taxable",
            !!(res.data as any)?.taxable || !!(res.data as any)?.isTaxable,
          );
          if ((res.data as any)?.taxProcedureId) {
            setValue("taxProcedureId", {
              value: (res.data as any).taxProcedureId,
              label:
                (res.data as any)?.taxProcedureTitle ||
                (res.data as any).taxProcedureId,
              percentageValue: (res.data as any)?.taxPercentageValue,
            });
          }
          setTaxPercentage(
            ((res.data as any)?.purchaseInvoiceItem?.[0]?.taxPercentage ||
              (res.data as any)?.purchaseInvoiceService?.[0]?.taxPercentage ||
              0) / 100,
          );
          setLoading(false);
        } else {
          setIsDataAvailable(false);
          getPOById();
        }
      })
      .catch((err: any) => {
        console.error("===", err);
        setLoading(false);
      });
  };
  const getPOById = async () => {
    await poByIdFetch()
      .then((res: NewPurchaseOrderResponse | unknown | any) => {
        if (res?.data?.success) {
          setInvoice(res.data.data);
          if (res?.data.data?.status === 2) setPartsLoader(false);
          setPurchaseInvoiceItem(res?.data.data?.purchaseOrderItems || []);
          setValue(
            "purchaseInvoiceItem",
            res?.data.data.purchaseOrderItems || [],
          );
          if (currentStep - 1 === steps.indexOf("Purchase Order")) {
            setPurchaseInvoiceService(res?.data.data?.purchaseOrderSvc || []);
            setValue(
              "purchaseInvoiceService",
              res?.data.data?.purchaseOrderSvc || [],
            );
          }
          setValue("storeId", res?.data.data?.storeId);
          setValue("supplierId", res?.data.data?.supplierId);
          setValue("poId", params?.id);
          setValue("comments", res?.data.data?.poMemo);
          setValue("invoiceDate", dayjs(new Date())?.format("YYYY-MM-DD"));
          const poTaxable = !!(
            res?.data.data?.taxable || (res?.data.data as any)?.isTaxable
          );
          setValue("taxable", poTaxable);
          if (poTaxable && res?.data.data?.taxProcedureId) {
            setValue("taxProcedureId", {
              value: res.data.data.taxProcedureId,
              label:
                (res.data.data as any)?.taxProcedureTitle ||
                res.data.data.taxProcedureId,
              percentageValue: (res.data.data as any)?.taxPercentageValue,
            });
            getTaxPercentage(res.data.data.taxProcedureId || 0);
          } else {
            setValue("taxProcedureId", null);
            setTaxPercentage(0);
          }
        } else {
          enqueueSnackbar(
            <AlertMessages
              text={res?.data?.message || "Something went wrong"}
            />,
            { variant: "error" },
          );
        }
      })
      .catch((err) => {
        console.error("===", err);
      })
      .finally(() => setLoading(false));
    // InventoryProfileService.getPurchaseOrderById(params?.id).then((res: NewPurchaseOrderResponse) => {
    //     if(res.success) {
    //         setInvoice(res.data);
    //         if(res.data?.status === 2) setPartsLoader(false);
    //         setPurchaseInvoiceItem(res.data?.purchaseOrderItems || []);
    //         setValue('purchaseInvoiceItem', res.data.purchaseOrderItems || []);
    //         if(currentStep - 1 === steps.indexOf('Purchase Order')) {
    //             setPurchaseInvoiceService(res.data?.purchaseOrderSvc || []);
    //             setValue('purchaseInvoiceService', res.data?.purchaseOrderSvc || []);
    //         }
    //         setValue('storeId', res.data?.storeId);
    //         setValue('supplierId', res.data?.supplierId);
    //         setValue('poId', params?.id);
    //         setValue('comments', res.data?.poMemo);
    //         setValue('invoiceDate', dayjs(new Date())?.format('YYYY-MM-DD'));
    //         getTaxPercentage(res.data?.taxProcedureId);
    //         setLoading(false);
    //     } else {
    //         enqueueSnackbar(<AlertMessages text={res.message || "Something went wrong"} />, { variant: 'error' });
    //         setLoading(false);
    //     }
    // }).catch((err:any) => { console.error("===", err); setLoading(false); });
  };
  const getTaxPercentage = (taxId: number | null) => {
    if (!taxId) {
      setTaxPercentage(0);
      return;
    }
    TaxProcedureProfileService.getTaxProcedureById(taxId)
      .then((res: GetDefaultTaxProcedureResponse) => {
        setTaxPercentage((res?.data?.percentageValue || 0) / 100);
        if (res?.data?.id) {
          setValue("taxProcedureId", {
            value: res.data.id,
            label: res.data.title,
            percentageValue: res.data.percentageValue,
          });
        }
      })
      .catch((err: any) => {
        console.error("===", err);
      });
  };
  const taxProcedureOptions = (
    taxProceduresData?.pages[0]?.data?.content || []
  ).map((item: { id: number; title: string; percentageValue?: number }) => ({
    value: item.id,
    label: item.title,
    percentageValue: item.percentageValue,
  }));
  const columns = [
    { id: "itemId" },
    { id: "itemCode" },
    { id: "unitId" },
    {
      id: "itemName",
      label: t("Item") + " *",
      numeric: false,
      disablePadding: false,
      type: "text",
    },
    {
      id: "supplierSKU",
      label: t("SKU"),
      numeric: false,
      disablePadding: false,
      type: "text",
    },
    {
      id: "quantity",
      label: t("Quantity"),
      numeric: false,
      disablePadding: false,
      type: "number",
    },
    { id: "unitTitle" },
    {
      id: "unitPrice",
      label: t("Cost"),
      numeric: false,
      disablePadding: false,
      type: "number",
    },
    {
      id: "discount",
      label: `${t("Discount")} %`,
      numeric: false,
      disablePadding: false,
      type: "number",
    },
    { id: "total", label: t("Total") },
  ];
  const columnsService = [
    { id: "serviceId" },
    { id: "serviceCode" },
    {
      id: "serviceName",
      label: t("service") + " *",
      numeric: false,
      disablePadding: false,
      type: "text",
    },
    {
      id: "quantity",
      label: t("Quantity"),
      numeric: false,
      disablePadding: false,
      type: "number",
    },
    {
      id: "unitPrice",
      label: t("Cost"),
      numeric: false,
      disablePadding: false,
      type: "number",
    },
    {
      id: "discount",
      label: `${t("Discount")} %`,
      numeric: false,
      disablePadding: false,
      type: "number",
    },
    { id: "total", label: t("Total") },
  ];
  const DeleteItem = (row: any, typeName: string) => {
    if (typeName === "purchaseInvoiceItem" && IsDataAvailable) {
      setLoading(true);
      InventoryProfileService.deleteEntityItem(
        (row as any).id,
        "purchaseinvoiceitems",
      )
        .then((response: DeleteData) => {
          if (response.success)
            enqueueSnackbar(
              <AlertMessages
                statusCode={response.status}
                text={t("deleted") + " " + t("successfully")}
              />,
              { variant: "success" },
            );
          else
            enqueueSnackbar(<AlertMessages text={response?.message} />, {
              variant: "error",
            });
          setLoading(false);
          getStockReceiptByPOId();
        })
        .catch((err: any) => {
          console.error("===", err);
          enqueueSnackbar(
            <AlertMessages
              text={
                err?.message || err?.data?.message || "Something went wrong"
              }
            />,
            { variant: "error" },
          );
          setLoading(false);
        });
    } else if (typeName === "purchaseInvoiceItem" && !IsDataAvailable) {
      setPurchaseInvoiceItem((prevRows) => {
        const newRows = prevRows.filter((rows) => rows.id !== row.id);
        setValue("purchaseInvoiceItem", []);
        setTimeout(
          () =>
            setValue("purchaseInvoiceItem", newRows, {
              shouldValidate: true,
              shouldDirty: true,
            }),
          0,
        );
        return newRows;
      });
    }
    if (typeName === "purchaseInvoiceService" && IsDataAvailable) {
      setLoading(true);
      InventoryProfileService.deleteEntityItem(
        (row as any).id,
        "purchaseinvoiceservices",
      )
        .then((response: DeleteData) => {
          if (response.success)
            enqueueSnackbar(
              <AlertMessages
                statusCode={response.status}
                text={t("deleted") + " " + t("successfully")}
              />,
              { variant: "success" },
            );
          else
            enqueueSnackbar(<AlertMessages text={response?.message} />, {
              variant: "error",
            });
          setLoading(false);
          getStockReceiptByPOId();
        })
        .catch((err: any) => {
          console.error("===", err);
          enqueueSnackbar(
            <AlertMessages
              text={
                err?.message || err?.data?.message || "Something went wrong"
              }
            />,
            { variant: "error" },
          );
          setLoading(false);
        });
    } else if (typeName === "purchaseInvoiceService" && !IsDataAvailable) {
      setPurchaseInvoiceService((prevRows) => {
        const newRows = prevRows.filter((rows) => rows.id !== row.id);
        setValue("purchaseInvoiceService", []);
        setTimeout(
          () =>
            setValue("purchaseInvoiceService", newRows, {
              shouldValidate: true,
              shouldDirty: true,
            }),
          0,
        );
        return newRows;
      });
    }
  };
  const addNewItem = (typeName: string) => {
    if (typeName === "purchaseInvoiceItem") {
      const newItem = columns.reduce(
        (acc, column) => ({
          ...acc,
          [column.id]: column.type === "number" ? 0 : "",
        }),
        {},
      );
      if (!IsDataAvailable) (newItem as any).id = Date.now();
      setPurchaseInvoiceItem((prevRows) => [...prevRows, newItem]);
    } else {
      const newService = columnsService.reduce(
        (acc, column) => ({
          ...acc,
          [column.id]: column.type === "number" ? 0 : "",
        }),
        {},
      );
      if (!IsDataAvailable) (newService as any).id = Date.now();
      setPurchaseInvoiceService((prevRows) => [...prevRows, newService]);
    }
  };
  const handleItem = (row: any, typeName: string, action: string) => {
    if (typeName === "purchaseInvoiceItem" && IsDataAvailable) {
      if (action === "create") {
        InventoryProfileService.createPurchaseInvoiceItem({
          ...row,
          poId: params?.id,
          purchaseInvoiceId: po?.id,
          storeId: po?.storeId,
        })
          .then((response: SaveInvoiceResponse) => {
            if (response.success)
              enqueueSnackbar(
                <AlertMessages
                  statusCode={response.status}
                  text={
                    t("supplierBillItem") +
                    " " +
                    t("created") +
                    " " +
                    t("successfully")
                  }
                />,
                { variant: "success" },
              );
            else
              enqueueSnackbar(<AlertMessages text={response?.message} />, {
                variant: "error",
              });
            getStockReceiptByPOId();
          })
          .catch((err: any) => {
            console.error("===", err);
            enqueueSnackbar(
              <AlertMessages
                text={
                  err?.message || err?.data?.message || "Something went wrong"
                }
              />,
              { variant: "error" },
            );
            getStockReceiptByPOId();
          });
      } else {
        InventoryProfileService.updatePurchaseInvoiceItem({
          ...row,
          poId: params?.id,
          purchaseInvoiceId: po?.id,
        })
          .then((response: SaveInvoiceResponse) => {
            if (response.success)
              enqueueSnackbar(
                <AlertMessages
                  statusCode={response.status}
                  text={
                    t("supplierBillItem") +
                    " " +
                    t("updated") +
                    " " +
                    t("successfully")
                  }
                />,
                { variant: "success" },
              );
            else
              enqueueSnackbar(<AlertMessages text={response?.message} />, {
                variant: "error",
              });
            getStockReceiptByPOId();
          })
          .catch((err: any) => {
            console.error("===", err);
            enqueueSnackbar(
              <AlertMessages
                text={
                  err?.message || err?.data?.message || "Something went wrong"
                }
              />,
              { variant: "error" },
            );
            getStockReceiptByPOId();
          });
      }
    } else if (typeName === "purchaseInvoiceService" && IsDataAvailable) {
      if (action === "create") {
        InventoryProfileService.createPurchaseInvoiceService({
          ...row,
          poId: params?.id,
          purchaseInvoiceId: po?.id,
          storeId: po?.storeId,
        })
          .then((response: SaveInvoiceResponse) => {
            if (response.success)
              enqueueSnackbar(
                <AlertMessages
                  statusCode={response.status}
                  text={
                    t("Purchase Order Service") +
                    " " +
                    t("created") +
                    " " +
                    t("successfully")
                  }
                />,
                { variant: "success" },
              );
            else
              enqueueSnackbar(<AlertMessages text={response?.message} />, {
                variant: "error",
              });
            getInvoiceById();
          })
          .catch((err: any) => {
            console.error("===", err);
            enqueueSnackbar(
              <AlertMessages
                text={
                  err?.message || err?.data?.message || "Something went wrong"
                }
              />,
              { variant: "error" },
            );
            getInvoiceById();
          });
      } else {
        InventoryProfileService.updatePurchaseInvoiceService({
          ...row,
          poId: params?.id,
          purchaseInvoiceId: po?.id,
        })
          .then((response: SaveInvoiceResponse) => {
            if (response.success)
              enqueueSnackbar(
                <AlertMessages
                  statusCode={response.status}
                  text={
                    t("Purchase Order Service") +
                    " " +
                    t("updated") +
                    " " +
                    t("successfully")
                  }
                />,
                { variant: "success" },
              );
            else
              enqueueSnackbar(<AlertMessages text={response?.message} />, {
                variant: "error",
              });
            getInvoiceById();
          })
          .catch((err: any) => {
            console.error("===", err);
            enqueueSnackbar(
              <AlertMessages
                text={
                  err?.message || err?.data?.message || "Something went wrong"
                }
              />,
              { variant: "error" },
            );
            getInvoiceById();
          });
      }
    }
  };

  const handleInputChange = (
    index: number,
    columnId: string,
    value: any,
    typeName: string,
    type: string,
  ) => {
    if (typeName === "purchaseInvoiceItem") {
      const updatedItems = [...purchaseInvoiceItem];
      updatedItems[index][columnId] =
        type === "number" ? parseFloat(value) : value;
      setPurchaseInvoiceItem(updatedItems);
    } else {
      const updatedServices = [...purchaseInvoiceService];
      updatedServices[index][columnId] = value;
      setPurchaseInvoiceService(updatedServices);
    }
  };
  const onSubmit = (data: FormData) => {
    if (Object.values(data)?.length) {
      if (checkStatus === 1) {
        const filteredItems = purchaseInvoiceItem.filter(
          (item: any) => item?.itemName,
        );
        const filteredServices = purchaseInvoiceService.filter(
          (service: any) => service?.serviceName,
        );
        if (filteredItems.length === 0 && filteredServices.length === 0) {
          enqueueSnackbar(<AlertMessages text={t("addAtLeastOneItem")} />, {
            variant: "error",
          });
          return;
        }
        if (IsDataAvailable) {
          setConfirm(true);
          setEntity({ ...data });
        } else {
          setLoading(true);
          filteredItems.every((row: any) => delete row.unitTitle);
          const { taxProcedureId, taxable, ...rest } = data;
          const invoicePayload = {
            ...rest,
            taxable: !!taxable,
            isTaxable: !!taxable,
            taxProcedureId:
              taxable && taxProcedureId?.value ? taxProcedureId.value : null,
            purchaseInvoiceItem: filteredItems,
            purchaseInvoiceService: filteredServices,
          };
          if (currentStep - 1 === steps.indexOf("Purchase Order")) {
            InventoryProfileService.savePurchaseInvoice(invoicePayload)
              .then((response: SaveInvoiceResponse) => {
                if (response.success)
                  enqueueSnackbar(
                    <AlertMessages
                      statusCode={response.status}
                      text={
                        t("supplierBill") +
                        " " +
                        t("saved") +
                        " " +
                        t("successfully")
                      }
                    />,
                    { variant: "success" },
                  );
                else
                  enqueueSnackbar(<AlertMessages text={response?.message} />, {
                    variant: "error",
                  });
                getStockReceiptByPOId();
                setLoading(false);
              })
              .catch((err: any) => {
                console.error("===", err);
                setLoading(false);
                enqueueSnackbar(
                  <AlertMessages
                    text={
                      err?.message ||
                      err?.data?.message ||
                      "Something went wrong"
                    }
                  />,
                  { variant: "error" },
                );
              });
          } else {
            InventoryProfileService.saveStockInvoice(invoicePayload)
              .then((response: SaveInvoiceResponse) => {
                if (response.success)
                  enqueueSnackbar(
                    <AlertMessages
                      statusCode={response.status}
                      text={
                        t("supplierBill") +
                        " " +
                        t("saved") +
                        " " +
                        t("successfully")
                      }
                    />,
                    { variant: "success" },
                  );
                else
                  enqueueSnackbar(<AlertMessages text={response?.message} />, {
                    variant: "error",
                  });
                getStockReceiptByPOId();
                setLoading(false);
              })
              .catch((err: any) => {
                console.error("===", err);
                setLoading(false);
                enqueueSnackbar(
                  <AlertMessages
                    text={
                      err?.message ||
                      err?.data?.message ||
                      "Something went wrong"
                    }
                  />,
                  { variant: "error" },
                );
              });
          }
        }
      } else {
        // if(currentStep + 1 === steps.indexOf('Stock Received')) {
        //     setCurrentStep(steps.indexOf('Stock Received'));
        //     setCurrentSteps(steps.indexOf('Stock Received'));
        // } else {
        //     setCurrentStep(steps.indexOf('Debit Note'));
        //     setCurrentSteps(steps.indexOf('Debit Note'));
        // }
        setCurrentStep(steps.indexOf("supplierPayment"));
        setCurrentSteps(steps.indexOf("supplierPayment"));
      }
    }
  };
  const calculateTotals = () => {
    const itemTotals = purchaseInvoiceItem.reduce(
      (acc, item) => {
        const unitPrice = parseFloat(item.unitPrice || 0);
        const quantity = parseFloat(item.quantity || 0);
        const discountPercentage = parseFloat(item.discount || 0);
        const discountAmount = (unitPrice * discountPercentage) / 100; // Calculate discount as a percentage of unitPrice
        const totalAfterDiscount = (unitPrice - discountAmount) * quantity;
        return {
          unitPrice: parseFloat(acc.unitPrice) + unitPrice,
          discount: parseFloat(acc.discount) + discountAmount * quantity,
          subTotal: parseFloat(acc.subTotal) + unitPrice * quantity,
          total: parseFloat(acc.total) + totalAfterDiscount,
        };
      },
      { unitPrice: 0, discount: 0, subTotal: 0, total: 0 },
    );

    const serviceTotals = purchaseInvoiceService?.reduce(
      (acc, service) => {
        const unitPrice = parseFloat(service.unitPrice || 0);
        const quantity = parseFloat(service.quantity || 0);
        const discountPercentage = parseFloat(service.discount || 0);
        const discountAmount = (unitPrice * discountPercentage) / 100; // Calculate discount as a percentage of unitPrice
        const totalAfterDiscount = (unitPrice - discountAmount) * quantity;
        return {
          unitPrice: parseFloat(acc?.unitPrice) + unitPrice,
          discount: parseFloat(acc?.discount) + discountAmount * quantity,
          subTotal: parseFloat(acc?.subTotal) + unitPrice * quantity,
          total: parseFloat(acc?.total) + totalAfterDiscount,
        };
      },
      { unitPrice: 0, discount: 0, subTotal: 0, total: 0 },
    );

    return {
      unitPrice: itemTotals.unitPrice + serviceTotals?.unitPrice,
      discount: itemTotals.discount + serviceTotals?.discount,
      subTotal: itemTotals.subTotal + serviceTotals?.subTotal,
      taxableTotal: itemTotals.total,
      total: itemTotals.total + serviceTotals?.total,
    };
  };
  const totals = calculateTotals();
  const handleDropdownActions = (
    typeName: string,
    action: "searchIt" | "loadNext",
    search?: string,
    table?: string,
  ) => {
    if (action === "searchIt") {
      setDropdownPage(1);
      setDropdownSearchTerm(search);
      if (search) setSearchLoading(typeName);
    } else {
      setDropdownPage(dropdownPage + 1);
      setSearchLoading(typeName);
    }
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      if (table === "inventoryServices") {
        servicesRefetch().finally(() => setSearchLoading(null));
        return;
      }
      if (typeName === "taxProcedures")
        taxProceduresRefetch().finally(() => setSearchLoading(null));
      else itemsRefetch().finally(() => setSearchLoading(null));
    }, 300);
  };
  const effectiveTaxPercentage = watch("taxable") ? taxPercentage : 0;
  return loading ? (
    <Loader />
  ) : (
    <Grid
      container
      component="form"
      id="form"
      className="px-[8px] items-baseline"
      rowGap={2.5}
      columnGap={4}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid container className="items-center ">
        <Grid item xs={12} sm={6} className="text-start">
          <Typography
            className="font-Saira text-[15px] font-semibold"
            style={{ color: themeColors?.primary }}
          >
            {IsDataAvailable ? t("supplierBill") : t("newSupplierBill")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} className="hide-on-print">
          <div className="flex gap-2 justify-end">
            <Button
              type="submit"
              className="primary"
              style={{ background: themeColors?.primary }}
              variant="contained"
              disableElevation
              onClick={() => onSubmit(handleSubmit(onSubmit))}
            >
              {IsDataAvailable
                ? checkStatus === 1
                  ? t("Authorize")
                  : t("Next")
                : t("save")}
            </Button>
            {/*  <Button className="secondary" variant="contained" disableElevation>{t('email')}</Button> */}
            {checkStatus === 2 || checkStatus === 3 ? (
              <Button
                className="secondary"
                style={{ color: themeColors?.primary }}
                variant="contained"
                disableElevation
                onClick={() =>
                  navigate(`${window.location.pathname}/print/supplier-bill`)
                }
              >
                {t("Print")}
              </Button>
            ) : null}
            <Button
              className="secondary"
              style={{ color: themeColors?.primary }}
              variant="contained"
              disableElevation
              onClick={handleBack}
            >
              {t("Back to list")}
            </Button>
          </div>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider className="bg-[#AEB3C4] hide-on-print" />
      </Grid>
      <Grid
        container
        className="py-[12px] px-[18px] rounded-[8px] mb-[16px] items-center"
        style={{ background: themeColors?.primary }}
      >
        <Grid item xs={4}>
          <Typography className="font-Saira text-[15px] font-bold text-[#fff] text-left">
            {IsDataAvailable ? t("supplierBill") : t("newSupplierBill")}
          </Typography>
          <Typography className="font-Saira text-[13px] text-[#fff] text-left">
            <span className="font-bold">
              {IsDataAvailable
                ? t("supplierBill") + " #"
                : t("Purchase Order") + " #"}{" "}
            </span>{" "}
            <span>
              {(po as any)?.invoiceNumber
                ? (po as any)?.invoiceNumber || ""
                : po?.poNumber}
            </span>
          </Typography>
          <Typography className="font-Saira text-[13px] text-[#fff] text-left">
            <span className="font-bold">{t("Date")}</span>{" "}
            <span>{po?.poDate?.split("T")[0] || ""}</span>
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <div className="flex justify-end gap-10">
            <Typography className="font-Saira text-[11px] text-[#fff] text-center">
              <span className="font-bold">
                {t("Supplier")} {t("name")}
              </span>{" "}
              <br />
              <span className="font-medium">{po?.vendorTitle || ""}</span>
            </Typography>
            <Typography className="font-Saira text-[11px] text-[#fff] text-center">
              <span className="font-bold">{t("Requested")}</span> <br />
              <span className="font-medium">{po?.totalQuantity || 0}</span>
            </Typography>
            <Typography className="font-Saira text-[11px] text-[#fff] text-center">
              <span className="font-bold">{t("Received")}</span> <br />
              <span className="font-medium">
                {po?.totalReceivedQuantity || 0}
              </span>
            </Typography>
            <Typography className="font-Saira text-[11px] text-[#fff] text-center">
              <span className="font-bold">{t("Subtotal")}</span> <br />
              <span className="font-medium">
                {new Intl.NumberFormat("en-US", {}).format(
                  (po as PurchaseOrderResponse)?.subtotalAmount || 0,
                ) || 0}
              </span>
            </Typography>
            <Typography className="font-Saira text-[11px] text-[#fff] text-center">
              <span className="font-bold">{t("Discount")}</span> <br />
              <span className="font-medium">
                {new Intl.NumberFormat("en-US", {}).format(
                  (po as PurchaseOrderResponse)?.discount || 0,
                ) || 0}
              </span>
            </Typography>
            <Typography className="font-Saira text-[11px] text-[#fff] text-center">
              <span className="font-bold">{t("tax")}</span> <br />
              <span className="font-medium">
                {new Intl.NumberFormat("en-US", {}).format(
                  (po as PurchaseOrderResponse)?.taxAmount || 0,
                ) || 0}
              </span>
            </Typography>
            <Typography className="font-Saira text-[11px] text-[#fff] text-center">
              <span className="font-bold">{t("Total")}</span> <br />
              <span className="font-medium">
                {new Intl.NumberFormat("en-US", {}).format(
                  (po as PurchaseOrderResponse)?.totalAmount || 0,
                ) || 0}
              </span>
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Grid container item xs={12} gap={2.5}>
        <Grid item xs={12}>
          <Typography
            className="font-Saira text-[13px] leading-[16px] font-semibold text-left"
            style={{ color: themeColors?.primary }}
          >
            {t("supplierBill")} {t("Details")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Controller
            name="invoiceDate"
            control={control}
            rules={{
              validate: (value) => {
                const date = new Date(value);
                return isNaN(date.getTime()) ? t("Invalid Date") : true;
              },
            }}
            render={({ field }) => (
              <BasicDatePicker
                type="datePicker"
                {...field}
                label={t("supplierBill") + " " + t("Date")}
                fullWidth
                onChange={(value: any) =>
                  field.onChange(
                    new Date(value)
                      .toLocaleDateString("en-CA", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                      ?.split("/")
                      .reverse()
                      .join("-"),
                  )
                }
                required={true}
                error={errors.invoiceDate?.message as string}
                disable={
                  checkStatus === 2 || checkStatus === 3 || checkStatus === 4
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Controller
            name="dueDate"
            control={control}
            rules={{
              validate: (value) => {
                const date = new Date(value);
                return isNaN(date.getTime()) && value
                  ? t("Invalid Date")
                  : true;
              },
            }}
            render={({ field }) => (
              <BasicDatePicker
                type="datePicker"
                {...field}
                label={t("Due") + " " + t("Date")}
                fullWidth
                onChange={(value: any) =>
                  field.onChange(
                    new Date(value)
                      .toLocaleDateString("en-CA", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                      ?.split("/")
                      .reverse()
                      .join("-"),
                  )
                }
                required={false}
                error={errors.dueDate?.message as string}
                disable={
                  checkStatus === 2 || checkStatus === 3 || checkStatus === 4
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <TextField
            {...register("referenceNumber", {
              validate: {
                required: (value) =>
                  value?.trim() !== "" || t("This field is required."),
              },
            })}
            placeholder="REF-001"
            label={t("referenceNo") + " *"}
            title={t("referenceNo")}
            fullWidth
            error={!!errors.referenceNumber}
            helperText={errors.referenceNumber?.message as string}
            InputLabelProps={{ shrink: true }}
            disabled={
              checkStatus === 2 || checkStatus === 3 || checkStatus === 4
            }
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Controller
            name="taxable"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <CommonCheckbox
                {...field}
                label={t("Tax Exclusive")}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  field.onChange(event.target.checked);
                  if (!event.target.checked) {
                    resetField("taxProcedureId");
                    setTaxPercentage(0);
                  }
                }}
                checked={field.value}
                color={themeColors?.primary}
                disabled={
                  checkStatus === 2 || checkStatus === 3 || checkStatus === 4
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          {watch("taxable") ? (
            <Controller
              name="taxProcedureId"
              control={control}
              defaultValue={null}
              rules={{
                required: watch("taxable")
                  ? t("This field is required.")
                  : false,
              }}
              render={({ field }) => (
                <DynamicSelect
                  label={t("Tax Procedures") + " *"}
                  defaultPlaceholder="phSelectTaxProcedure"
                  {...field}
                  options={taxProcedureOptions}
                  isClearable
                  isSearchable
                  isDisabled={
                    checkStatus === 2 || checkStatus === 3 || checkStatus === 4
                  }
                  onChange={(selectedOption: any) => {
                    field.onChange(selectedOption);
                    setTaxPercentage(
                      (selectedOption?.percentageValue || 0) / 100,
                    );
                  }}
                  error={errors.taxProcedureId?.message as string}
                  isLoading={searchLoading === "taxProcedures"}
                  onInputChange={(
                    search: string,
                    { action }: { action: string },
                  ) => {
                    if (
                      action === "input-change" ||
                      (action !== "set-value" &&
                        action !== "menu-close" &&
                        action !== "input-blur")
                    )
                      handleDropdownActions(
                        "taxProcedures",
                        "searchIt",
                        search,
                      );
                    else if (
                      action === "input-blur" ||
                      action === "menu-close"
                    ) {
                      if (dropdownSearchTerm || dropdownPage > 1)
                        handleDropdownActions("taxProcedures", "searchIt", "");
                      else setDropdownSearchTerm("");
                      setDropdownPage(1);
                    }
                  }}
                  onMenuScrollToBottom={() => {
                    if (!(taxProceduresData?.pages[0]?.data as any).last)
                      handleDropdownActions("taxProcedures", "loadNext");
                  }}
                  page={dropdownPage}
                />
              )}
            />
          ) : null}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          {partsLoader ? (
            <Box sx={{ "& .MuiBackdrop-root": { zIndex: 999 } }}>
              <Loader />
            </Box>
          ) : null}
          <NewPurchaseSteps
            form={{
              control,
              register,
              handleSubmit,
              setValue,
              errors,
              watch,
              resetField,
            }}
            addNewItem={addNewItem}
            handleInputChange={handleInputChange}
            items={itemsData?.pages[0]?.data?.content || []}
            services={servicesData?.pages[0]?.data?.content || []}
            DeleteItem={DeleteItem}
            handleItem={handleItem}
            checkStatus={checkStatus}
            {...{
              currentStep,
              setCurrentStep,
              columns,
              columnsService,
              purchaseInvoiceItem,
              purchaseInvoiceService,
              loggedInUserCurrency,
              params,
              IsDataAvailable,
              steps,
              po,
              setCurrentSteps,
              t,
              themeColors,
              allStatuses,
              dropdownPage,
              searchLoading,
              dropdownSearchTerm,
              setDropdownSearchTerm,
              setDropdownPage,
            }}
            itemsData={itemsData || {}}
            handleDropdownActions={handleDropdownActions}
            servicesData={servicesData || {}}
          />
        </Grid>
      </Grid>
      <Typography className="font-Saira text-[11px] font-semibold text-[#171826] text-left mb-[-5px]">
        {t("Comments")}
      </Typography>
      <Grid container xs={12} spacing={1}>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("comments")}
            placeholder={t("Comments")}
            title={t("Comments")}
            fullWidth
            error={!!errors.comments}
            helperText={errors.comments?.message as string}
            InputLabelProps={{ shrink: true }}
            multiline
            rows={5}
            sx={{
              "& .MuiInputBase-fullWidth.MuiInputBase-multiline": {
                width: "100%",
              },
            }}
            // disabled={checkStatus === 2}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            className="bg-[#D8D1E0] rounded-[8px]"
            sx={{
              border: "1px solid #5f6770",
              width: "calc(100% + 8px)",
              padding: "8px 14px",
            }}
          >
            <Box className="flex justify-end gap-12 mt-[9px]">
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] w-[auto]">
                {t("Subtotal")}
              </Typography>
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] w-[20%] text-end">
                <span className="uppercase">{loggedInUserCurrency}</span>{" "}
                {new Intl.NumberFormat("en-US", {}).format(
                  totals.subTotal ||
                    (po as PurchaseOrderResponse)?.subtotalAmount ||
                    0,
                )}
              </Typography>
            </Box>
            <Box className="flex justify-end gap-12 mt-[9px]">
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] w-[auto]">
                {t("Discount")}
              </Typography>
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] w-[20%] text-end">
                <span className="uppercase">{loggedInUserCurrency}</span>{" "}
                {new Intl.NumberFormat("en-US", {}).format(
                  !IsDataAvailable
                    ? totals.discount
                    : (po as PurchaseOrderResponse)?.discount || 0,
                )}
              </Typography>
            </Box>
            <Box className="flex justify-end gap-12 mt-[9px]">
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] w-[auto]">
                {t("tax")}
                {` (${effectiveTaxPercentage * 100}%)`}
              </Typography>
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] w-[20%] text-end">
                <span className="uppercase">{loggedInUserCurrency}</span>{" "}
                {new Intl.NumberFormat("en-US", {}).format(
                  !IsDataAvailable
                    ? totals.taxableTotal * effectiveTaxPercentage
                    : (po as PurchaseOrderResponse)?.taxAmount || 0,
                )}
              </Typography>
            </Box>
            <Box className="flex justify-end gap-12 mt-[9px]">
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] font-semibold w-[auto]">
                {t("totalWithTax")}
              </Typography>
              <Typography className="font-Saira text-[11px] text-[#3A3A3A] font-semibold w-[20%] text-end">
                <span className="uppercase">{loggedInUserCurrency}</span>{" "}
                {new Intl.NumberFormat("en-US", {}).format(
                  !IsDataAvailable
                    ? totals.total +
                        totals.taxableTotal * effectiveTaxPercentage
                    : (po as PurchaseOrderResponse)?.totalAmount || 0,
                )}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={12} className="hide-on-print">
        <Divider className="bg-[#AEB3C4] mt-[8px]" />
      </Grid>
      <Grid container className="items-center hide-on-print">
        <Grid item xs={12} sm={6} className="text-start"></Grid>
        <Grid item xs={12} sm={6}>
          <div className="flex gap-2 justify-end">
            <Button
              type="submit"
              className="primary"
              style={{ background: themeColors?.primary }}
              variant="contained"
              disableElevation
              onClick={() => onSubmit(handleSubmit(onSubmit))}
            >
              {IsDataAvailable
                ? checkStatus === 1
                  ? t("Authorize")
                  : t("Next")
                : t("save")}
            </Button>
            {/*  <Button className="secondary" style={{ color: themeColors?.primary }} variant="contained" disableElevation>{t('email')}</Button> */}
            {checkStatus === 2 || checkStatus === 3 ? (
              <Button
                className="secondary"
                style={{ color: themeColors?.primary }}
                variant="contained"
                disableElevation
                onClick={() =>
                  navigate(`${window.location.pathname}/print/supplier-bill`)
                }
              >
                {t("Print")}
              </Button>
            ) : null}
            <Button
              className="secondary"
              style={{ color: themeColors?.primary }}
              variant="contained"
              disableElevation
              onClick={handleBack}
            >
              {t("Back to list")}
            </Button>
          </div>
        </Grid>
      </Grid>
      {confirm && (
        <FormDialog
          open={confirm}
          onClose={(event, reason) =>
            event && reason !== "backdropClick" ? setConfirm(false) : ""
          }
          title={t("Authorize") + " " + t(steps[currentStep])}
          saveFunction={() => {
            delete entity.typeName;
            entity.purchaseInvoiceItem.every((row: any) => delete row.total);
            setConfirm(false);
            InventoryProfileService.changeStatusEntity({
              typeName: "purchaseinvoice",
              entityId: po?.id,
              status: 2,
            })
              .then((response: NewPurchaseOrderResponse) => {
                if (response.success) {
                  setConfirm(false);
                  // if(currentStep + 1 === steps.indexOf('Stock Received')) {
                  //     setCurrentStep(steps.indexOf('Stock Received'));
                  //     setCurrentSteps(steps.indexOf('Stock Received'));
                  // } else {
                  // setCurrentStep(steps.indexOf('Debit Note'));
                  // setCurrentSteps(steps.indexOf('Debit Note'));
                  //     navigate(`/inventory/purchase-invoice/${response.data.id}`);
                  // }
                  setCurrentStep(steps.indexOf("supplierPayment"));
                  setCurrentSteps(steps.indexOf("supplierPayment"));
                  getStockReceiptByPOId();
                  enqueueSnackbar(
                    <AlertMessages
                      statusCode={response.status}
                      text={
                        t("Status") +
                        " " +
                        t("changed") +
                        " " +
                        t("successfully")
                      }
                    />,
                    { variant: "success" },
                  );
                } else {
                  setConfirm(false);
                  enqueueSnackbar(<AlertMessages text={response?.message} />, {
                    variant: "error",
                  });
                }
              })
              .catch((err: any) => {
                console.error("===", err);
                setConfirm(false);
                enqueueSnackbar(
                  <AlertMessages
                    text={
                      err?.message ||
                      err?.data?.message ||
                      "Something went wrong"
                    }
                  />,
                  { variant: "error" },
                );
              });
          }}
          content={
            <>
              <Typography>{t("areYouSureUneditable")}</Typography>
            </>
          }
          submitButtonText="OK"
        />
      )}
    </Grid>
  );
};
interface NewPurchaseStepsProps {
  form: FormData;
  addNewItem: (typeName: string) => void;
  handleInputChange: (
    index: number,
    columnId: string,
    value: any,
    typeName: string,
    type: string,
  ) => void;
  currentStep: number;
  setCurrentStep: any;
  setCurrentSteps: any;
  columns: any[];
  columnsService: any[];
  purchaseInvoiceItem: any[];
  purchaseInvoiceService: any[];
  items: any[];
  services: any[];
  loggedInUserCurrency?: string;
  DeleteItem: (row: any, typeName: string) => void;
  params?: any;
  handleItem?: (row: any, typeName: string, action: string) => void;
  IsDataAvailable?: boolean;
  steps: string[];
  po?: any;
  t?: any;
  themeColors?: any;
  allStatuses?: PurchaseOrderStatuses;
  checkStatus: number | null;
  handleDropdownActions: (
    typeName: string,
    action: "searchIt" | "loadNext",
    search?: string,
  ) => void;
  dropdownPage: number;
  searchLoading: string | null;
  dropdownSearchTerm: any;
  setDropdownSearchTerm: any;
  setDropdownPage: any;
  itemsData: any;
  servicesData: any;
}

export const NewPurchaseSteps: React.FC<NewPurchaseStepsProps> = ({
  form,
  addNewItem,
  handleInputChange,
  currentStep,
  columns,
  columnsService,
  purchaseInvoiceItem,
  purchaseInvoiceService,
  items,
  services,
  loggedInUserCurrency,
  DeleteItem,
  params,
  handleItem,
  IsDataAvailable,
  steps,
  setCurrentStep,
  setCurrentSteps,
  t,
  themeColors,
  allStatuses,
  checkStatus,
  handleDropdownActions,
  itemsData,
  dropdownPage,
  searchLoading,
  dropdownSearchTerm,
  setDropdownSearchTerm,
  setDropdownPage,
  servicesData,
}) => {
  return (
    <>
      <Stepper
        className="hide-on-print"
        activeStep={currentStep}
        connector={<></>}
        sx={{
          "& .MuiStep-horizontal .Mui-active + .MuiStepLabel-labelContainer": {
            background: `linear-gradient(20.78deg, ${themeColors?.secondary}, ${themeColors?.secondary + "B3"})`,
          },
        }}
      >
        {steps.map((label, index) => {
          const statusKeyMap: Record<string, keyof PurchaseOrderStatuses> = {
            "Purchase Order": "purchaseOrder",
            supplierBill: "purchaseInvoice",
            "Stock Received": "stockReceive",
            "Debit Note": "purchaseCreditDebitNote",
            Unstock: "unStock",
          };
          const stepProps: { completed?: boolean } = {};
          const labelProps: { optional?: React.ReactNode } = {};
          const key = statusKeyMap[label];
          const isCompleted =
            allStatuses?.[key] === 2 ||
            allStatuses?.[key] === 3 ||
            allStatuses?.[key] === 4;
          const isSupplierBillCompleted =
            allStatuses?.purchaseInvoice === 2 ||
            allStatuses?.purchaseInvoice === 3 ||
            allStatuses?.purchaseInvoice === 4;
          return (
            <Step
              key={index}
              completed={isCompleted}
              {...stepProps}
              onClick={() => {
                if (
                  document
                    .querySelector(`.MuiStep-root:nth-child(${index + 1})`)
                    ?.classList.contains("Mui-completed") ||
                  (isSupplierBillCompleted &&
                    (label === "supplierPayment" || label === "Stock Received"))
                ) {
                  setCurrentStep(steps.indexOf(label));
                  setCurrentSteps(steps.indexOf(label));
                }
              }}
              className={`flex items-center ${document.querySelector(`.MuiStep-root:nth-child(${index + 1})`)?.classList.contains("Mui-completed") ? "cursor-pointer" : ""}`}
            >
              {/* {document.querySelector(`.MuiStep-root:nth-child(${index + 1})`)?.classList.contains('Mui-completed') ? <Completed style={{ fill: themeColors?.primary, width: '15px', height: '15px' }} /> : null} */}
              <StepLabel {...labelProps}>{t(label)}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Box className="bg-white py-[12px] px-[18px] rounded-[8px] mt-[16px]">
        <Typography className="font-Saira text-[11px] font-semibold text-[#171826] text-left">
          {t(steps[currentStep])}
        </Typography>
        <InventoryItemsTable
          form={form}
          columns={columns}
          handleInputChange={handleInputChange}
          rows={purchaseInvoiceItem}
          typeName="purchaseInvoiceItem"
          items={items}
          currency={loggedInUserCurrency}
          DeleteItem={DeleteItem}
          handleItem={handleItem}
          {...{
            params,
            dropdownPage,
            searchLoading,
            dropdownSearchTerm,
            setDropdownSearchTerm,
            setDropdownPage,
          }}
          checkStatus={checkStatus || 1}
          viewDelete={IsDataAvailable ? false : true}
          itemsResponse={itemsData || {}}
          handleDropdownActions={handleDropdownActions}
        />
        <Grid item xs={12} sm={6} className="hide-on-print">
          <div className="flex gap-2 justify-start">
            <Button
              className="secondary flex gap-1"
              style={{ color: themeColors?.primary }}
              variant="contained"
              disableElevation
              onClick={() => addNewItem("purchaseInvoiceItem")}
            >
              <AddIcon className="w-[20px] h-[20px]" /> {t("Add More Items")}
            </Button>
            {/* <Button className="secondary" style={{ color: themeColors?.primary }} variant="contained" disableElevation>{t('Import')}</Button>
                    <Button className="secondary" style={{ color: themeColors?.primary }} variant="contained" disableElevation>{t("Export")}</Button> */}
          </div>
        </Grid>
      </Box>
      {currentStep - 1 === steps.indexOf("Purchase Order") ? (
        <>
          <Box className="flex gap-2 justify-start mt-[16px]">
            <Button
              className="secondary cursor-text"
              style={{ color: themeColors?.primary }}
              variant="contained"
              disableElevation
            >
              {t("Additional Costs")}
            </Button>
          </Box>
          <Box className="bg-white py-[12px] px-[18px] rounded-[8px] mt-[16px]">
            <Typography className="font-Saira text-[11px] font-semibold text-[#171826] text-left">
              {t("Additional Cost")}
            </Typography>
            <InventoryServicesTable
              form={form}
              columns={columnsService}
              handleInputChange={handleInputChange}
              rows={purchaseInvoiceService}
              typeName="purchaseInvoiceService"
              services={services}
              currency={loggedInUserCurrency}
              DeleteItem={DeleteItem}
              handleItem={handleItem}
              {...{ params }}
              checkStatus={1}
              viewDelete={IsDataAvailable ? false : true}
              servicesResponse={servicesData || {}}
              handleDropdownActions={handleDropdownActions}
              {...{
                dropdownPage,
                searchLoading,
                dropdownSearchTerm,
                setDropdownSearchTerm,
                setDropdownPage,
              }}
            />
            <Grid item xs={12} sm={6} className="hide-on-print">
              <div className="flex gap-2 justify-start">
                <Button
                  className="secondary flex gap-1"
                  style={{ color: themeColors?.primary }}
                  variant="contained"
                  disableElevation
                  onClick={() => addNewItem("purchaseInvoiceService")}
                >
                  <AddIcon className="w-[20px] h-[20px]" />{" "}
                  {t("Add More Items")}
                </Button>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Divider className="bg-[#AEB3C4] mt-[15px] mb-[8px]" />
            </Grid>
          </Box>
        </>
      ) : null}
    </>
  );
};

export default PurchaseInvoice;
